import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IIncoterms } from "../incotermsModel";

export const getAllIncoterms = createAsyncThunk(
  "Incoterms/FindAllIncoterms",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/FindAllIncoterms`,
        {
          incoterms: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveIncoterms = createAsyncThunk(
  "Incoterms/FindAllActiveIncoterms",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Incoterms/FindAllActiveIncoterms`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Incoterms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createIncoterms = createAsyncThunk(
  "Incoterms/InsertIncoterms",
  async (IncotermsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/InsertIncoterms`,
        IncotermsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Incoterms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateIncoterms = createAsyncThunk(
  "Incoterms/UpdateIncoterms",
  async (IncotermsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/UpdateIncoterms`,
        IncotermsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Incoterms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getIncotermsByID = createAsyncThunk(
  "Incoterms/FindByIDIncoterms",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/FindByIDIncoterms`,
        { incoterms_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        incoterms_guid: result.incoterms_guid,
        incoterms: result.incoterms,
        isactive: result.isactive === true ? 1 : 2,
      } as IIncoterms;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Incoterms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const IncotermsActiveInactive = createAsyncThunk(
  "Incoterms/ActiveInActiveIncoterms",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/ActiveInActiveIncoterms`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Incoterms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteIncoterms = createAsyncThunk(
  "Incoterms/DeleteIncoterms",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Incoterms/DeleteIncoterms`,
        { incoterms_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting typeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
